import { Box, Divider, Switch, Typography } from "@mui/material";
import { TransForm } from "../../common/TransForm/Index";
import { PageTitle } from "../../common/PageTitle";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import _ from "lodash";
import { useCallback, useEffect } from "react";
import axios from "axios";
import { base_url } from '../../backendurl/url'
import { useState } from "react";
import tokenTransferInputs from "../../common/jsons/formConfigs/tokenTranferFormInputs";
import ModalPopUp from "../../common/TransForm/ModalPopUp";
import { Notification } from "../../common/Notification";
import { Config } from "../../../utils/commonFuctions/Token";
import { RefreshToken } from "../../../utils/commonFuctions/RefreshToken";
import { IOSSwitch } from "./SwitchStyles";
import { hasWritePermission } from "../../common/PermissionUtility";

export const TokenTransferForm = ({ mode, title }) => {
  const { selectedUser } = useSelector(
    (state) => state
  );
  const [popup, setPopup] = useState(false)
  const { user_uuid } = useParams("user_uuid");
  const [loading, setLoading] = useState(false)
  const [tokenTransferConfig, setTokenTransferConfig] = useState({
    status: true 
  })
  const [switchStatus, setSwitchStatus] = useState(true)
  const [isupdate, setIsupdate] = useState(false)
  const [configData, setConfigData] = useState()
  const [notification, setnotification] = useState(false)
  const [successNotification, setSuccessNotification] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [successMessage, setSuccessMessage] = useState('');
  const canWriteUsers = hasWritePermission('tokentransferlimit');

  console.log(switchStatus, "switchStatus")

  
  const handleSwitchChange = async (event) => {
    const newSwitchStatus = event.target.checked;
    setSwitchStatus(newSwitchStatus);
    
    // Update the config state
    setTokenTransferConfig(prev => ({
      ...prev,
      status: newSwitchStatus
    }));

    try {
      
      const statusPayload = {
        configurations: [
          {
            config_type: "token_transfer_enabled",
            value: newSwitchStatus ? 1.00 : 0.00,
            // is_active: newSwitchStatus
          }
        ]
      };

      await axios.put(`${base_url}/api/accounts/config/bulk-update/`, statusPayload, Config);
      
      setSuccessMessage(`Token transfer ${newSwitchStatus ? 'enabled' : 'disabled'} successfully`);
      setSuccessNotification(true);
      
    } catch(error) {
      setSwitchStatus(!newSwitchStatus);
      setTokenTransferConfig(prev => ({
        ...prev,
        status: !newSwitchStatus
      }));
      RefreshToken(error, setErrorMessage, setnotification);
    }
  };

  const SubmitTokenTransferConfig = async () => {
    try {
      
      const bulkUpdatePayload = {
        configurations: [
          {
            config_type: "min_tokens_per_transfer",
            value: parseFloat(configData.min_tokens_to_transfer)
          },
          {
            config_type: "max_tokens_per_transfer", 
            value: parseFloat(configData.max_tokens_to_transfer)
          },
          {
            config_type: "max_transfers_per_month",
            value: parseInt(configData.max_transfers_per_month)
          }
        ]
      };

      await axios.put(`${base_url}/api/accounts/config/bulk-update/`, bulkUpdatePayload, Config);
      
      setPopup(false);
      setSuccessMessage('Token transfer configuration updated successfully');
      setSuccessNotification(true);
      
      
      await getTokenTransferConfig();
      
    } catch(error) {
      const backendError = error?.response?.data?.data?.errors?.configurations?.[0];

      if (backendError) {
        // 👇 This will show the backend validation error
        setErrorMessage(backendError);
        setnotification(true);
      } else {
        RefreshToken(error, setErrorMessage, setnotification);
      }
      // RefreshToken(error, setErrorMessage, setnotification);
    }
  }

  const onSubmit = async (data) => {
    
    if (!switchStatus) {
      setErrorMessage('Token transfer is disabled. Please enable it to update configuration.')
      setnotification(true)
      return;
    }

    setTokenTransferConfig(data)
    
    // Convert string values to numbers and handle floating point values
    data.min_tokens_to_transfer = typeof data.min_tokens_to_transfer === 'string' ? 
      parseFloat(data.min_tokens_to_transfer) : data.min_tokens_to_transfer
    data.max_tokens_to_transfer = typeof data.max_tokens_to_transfer === 'string' ? 
      parseFloat(data.max_tokens_to_transfer) : data.max_tokens_to_transfer
    data.max_transfers_per_month = typeof data.max_transfers_per_month === 'string' ? 
      parseInt(data.max_transfers_per_month) : data.max_transfers_per_month

    
    data.status = switchStatus; 

    
    if (data.min_tokens_to_transfer > data.max_tokens_to_transfer) {
      setErrorMessage('Minimum tokens to transfer should not be higher than Maximum tokens to transfer')
      setnotification(true)
      return;
    }

    // Validation: Check if values are positive
    if (data.min_tokens_to_transfer <= 0 || data.max_tokens_to_transfer <= 0 || data.max_transfers_per_month <= 0) {
      setErrorMessage('All values must be greater than zero')
      setnotification(true)
      return;
    }

    // // Check: max transfers per month should NOT be greater than max tokens per transfer
    // if (data.max_transfers_per_month < data.max_tokens_to_transfer) {
    //   setErrorMessage('Maximum number of transfers per month should not be less than Maximum tokens to transfer');
    //   setnotification(true);
    //   return;
    // }

    delete data.Save
    
    setPopup(true)
    setnotification(false)
    setConfigData(data)
  };

  
  const transformApiDataToFormData = (apiData) => {
    const formData = {
      status: true 
    };
    
    
    if (Array.isArray(apiData)) {
      apiData.forEach(config => {
        switch(config.config_type) {
          case 'min_tokens_per_transfer':
            formData.min_tokens_to_transfer = parseFloat(config.value);
            break;
          case 'max_tokens_per_transfer':
            formData.max_tokens_to_transfer = parseFloat(config.value);
            break;
          case 'max_transfers_per_month':
            formData.max_transfers_per_month = parseInt(config.value);
            break;
          case 'token_transfer_enabled':
            
            const statusValue = parseFloat(config.value);
            formData.status = statusValue === 1.00;
            break;
        }
      });
    }
    
    else if (apiData.configurations && Array.isArray(apiData.configurations)) {
      apiData.configurations.forEach(config => {
        switch(config.config_type) {
          case 'min_tokens_per_transfer':
            formData.min_tokens_to_transfer = parseFloat(config.value);
            break;
          case 'max_tokens_per_transfer':
            formData.max_tokens_to_transfer = parseFloat(config.value);
            break;
          case 'max_transfers_per_month':
            formData.max_transfers_per_month = parseInt(config.value);
            break;
          case 'token_transfer_enabled':
            // Set switch status based on API value (1.00 = enabled, 0.00 = disabled)
            const statusValue = parseFloat(config.value);
            formData.status = statusValue === 1.00;
            break;
        }
      });
    }
    
    return formData;
  };

  const getTokenTransferConfig = useCallback(async () => {
    try {
      if (!loading) {
        setLoading(true)
        const response = await axios.get(`${base_url}/api/accounts/config/`, Config);
        console.log(response?.data, "tokenTransferConfigResponse")
        
        if (response?.data?.status === 'Success' && response.data.data) {
          console.log(response.data.data, "tokenTransferConfigResponse123")
          
          
          const transformedData = transformApiDataToFormData(response.data.data);
          console.log(transformedData, "transformedData");
          
          setTokenTransferConfig(transformedData);
          setSwitchStatus(transformedData.status);
          setIsupdate(true)
        } else if (!response.data.data || response.data.data.length === 0) {
          setIsupdate(false)
          
          setTokenTransferConfig({
            min_tokens_to_transfer: '',
            max_tokens_to_transfer: '',
            max_transfers_per_month: '',
            status: true
          });
          setSwitchStatus(true);
        }
        setLoading(false)
      }
    } catch(error) {
      setLoading(false)
      console.error("Error fetching config:", error);
      RefreshToken(error, setErrorMessage, setnotification)  
    }
  }, [selectedUser, user_uuid, loading]);

  useEffect(() => {
    getTokenTransferConfig();
  }, []);

  return (
    <Box>
      <Box sx={{ px: 6, pt: 3 }}>
        
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center', 
          mb: 1 
        }}>
          <PageTitle pageTitle={'Configuring Token Transfers'} />
          {
            canWriteUsers &&
            (
          <IOSSwitch
            checked={switchStatus}
            onChange={handleSwitchChange}
          />
          )}
        </Box>
        
        
        <Typography sx={{ 
          color: '#5F6672', 
          fontSize: '14px', 
          mb: 2 
        }}>
          Enter the data below to configure token transfer between users
        </Typography>
        
        <Divider sx={{ mb: 2, height: 4 }} />
      </Box>
      
      <TransForm
        submitAction={onSubmit}
        data={tokenTransferConfig}
        mode={mode}
        cardlength={'twoCard'}
        formInputs={tokenTransferInputs({ mode, isupdate, isEnabled: switchStatus })}
      />
      
      <ModalPopUp
        openpopup={popup}
        setPopup={setPopup}
        title={'Confirm the action ?'}
        subTitle={'Are you sure, you want to update token transfer configuration with given details.'}
        onClick={SubmitTokenTransferConfig}
        save={'Yes, Update'}
        cancel={'Exit'}
      />
      <Notification 
        message={errorMessage} 
        setopen={setnotification} 
        type={'error'} 
        show={notification} 
      />
      <Notification 
        message={successMessage} 
        setopen={setSuccessNotification} 
        type={'success'} 
        show={successNotification} 
      />
    </Box>
  );
};